var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckBubble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.511 3.792c.014.67-.35 1.574-.824 2.047a2.344 2.344 0 000 3.315c.467.466.811 1.274.824 1.933.013.584.241 1.164.686 1.608.411.412.96.656 1.542.684.697.035 1.61.44 2.104.934a2.343 2.343 0 003.315 0c.494-.493 1.407-.899 2.105-.934a2.335 2.335 0 001.541-.684 2.336 2.336 0 00.685-1.61c.013-.657.353-1.46.82-1.925a2.348 2.348 0 00.005-3.321c-.473-.472-.838-1.377-.824-2.046a2.337 2.337 0 00-1.502-2.234 2.337 2.337 0 00-.96-.153c-.63.032-1.425-.273-1.87-.72a2.344 2.344 0 00-3.315 0c-.445.446-1.24.752-1.87.72A2.337 2.337 0 001.68 2.871a2.336 2.336 0 00-.169.921zm8.666.729a.882.882 0 01.343 1.199l-2.44 4.393a.883.883 0 01-1.347.263L4.298 8.43a.882.882 0 011.103-1.378L7.036 8.36l1.942-3.497a.882.882 0 011.2-.342z",
    fill: "currentColor"
  })));
}

export default SvgCheckBubble;